import $ from 'jquery';
import moment from 'moment';
import Framework from 'framework';
import profileStore from 'framework/stores/ProfileStore';
import memberReferralService from 'framework/services/memberReferralService';
import memberReferralCouponService from 'framework/services/memberReferralCouponService';
import urlUtils from 'lib/url-utils';
import authUtils from 'lib/auth-utils';
import SessionStorage from 'lib/session-storage';
import Cookies from 'cookies-js';
import constants from 'lib/constants';

// multi-use reference constants
// id constants
const REFERRAL_ERROR_ID = '#referralErrorId';

// class constants
const MEMBER_REFERRAL_CLASS = '.member-referral';

// element reference constants
const REFERRAL_ELEMENT = $(MEMBER_REFERRAL_CLASS);

const DEFAULT_TEXT_ELEMENT = $('#defaultText');

const TWITTER_ICON_ELEMENT = $('.ico-twitter');
const FACEBOOK_ICON_ELEMENT = $('.ico-facebook');

const REFERRER_NAME_ELEMENT = $('span#referrerName');
const REFERRER_TEXT_ELEMENT = $('#referrerText');

const REFERRAL_FORM_ELEMENT = $('#memberReferralForm');
const REFERRAL_ERROR_ELEMENT = $(REFERRAL_ERROR_ID);
const REFERRAL_EMAIL_ELEMENT = $('a#referralEmailLink');
const REFERRAL_LANDING_ELEMENT = $(MEMBER_REFERRAL_CLASS + '-landing');

const LOADING_SPINNER_LG_ELEMENT = $(constants.loadingSpinnerLgClass);

const REFERRAL_ERROR_SPAN_ELEMENT = $(REFERRAL_ERROR_ID + ' span');

const REFERRAL_MEMBER_CONTENT_ELEMENT = $('.member-referral-content');
const REFERRAL_TM_CONTENT_ELEMENT = $('.teamMember-referral-content');
const REFERRAL_TM_CONTENT_TEXT = $('.tm-referral-content-text');
const REFERRAL_TM_CONTENT_SHARE = $('.teammemberReferralContentShare');
const REFERRAL_TM_ERROR_MSG = $('.teammemberReferralErrorMessages');
const REFERRAL_DIGITAL_CONTENT_SHARE = $('.digitalReferralContentShare');
const REFERRAL_DIGITAL_ERROR_MSG = $('.digitalReferralErrorMessages');
const REFERRAL_DIGITAL_CONTENT_TEXT = $('.digital-referral-content-text');
const REFERRAL_SHARING_CONTAINER_ELEMENT = $('.referral-sharing');

const memberReferralCookieDuration = 2592000; // 30 days

function addSocialSharing(url, el) {
	var fbUrl = el.find(FACEBOOK_ICON_ELEMENT).attr('href');
	fbUrl += encodeURIComponent(url);
	el.find(FACEBOOK_ICON_ELEMENT).attr('href', fbUrl);
	var twitterUrl = el.find(TWITTER_ICON_ELEMENT).attr('href');
	twitterUrl += 'url=' + encodeURIComponent(url) + '&text=Join me at Life Time with my referral code';
	el.find(TWITTER_ICON_ELEMENT).attr('href', twitterUrl);
}


function validateCodeResponse(response, isTm){
	if (response && response.isValid === false && response.message ==='Count Exceeded') {
		displayExceededLimitError(response);
	} else if (response && response.isValid === true) {
    	if (isTm)
    		addTmCodes(response);
    	else
			addMemberCodes(response);
	} else {
		displayGenericReferringText(response);
	}
}

function addCodes(referralBaseUrl, memberData, idPrefix, isTm) {
    // grab domain and page driver to construct URL
 	let referralUrl = referralBaseUrl;
	if(typeof memberData.webURL !== 'undefined' && memberData.webURL !== null ) {
    	// retrieve referral code from string returned in service response
    	const referralInfo = memberData.webURL.split('?referral=')[1].split('&source=');
    	referralUrl += '?referral=' + referralInfo[0] + '&source=' + referralInfo[1];
	} else if(memberData.isValid) {
    	referralUrl += '?referral=' + memberData.code + '&source=web';
	}

    if(isTm) {
        referralUrl += '&tm=true';
    }

    // add values to input fields
    $(`#${idPrefix}ReferralField`).val(referralUrl);

    // link up copy functionality
    /* eslint-disable no-undef, no-new */
    const clipboard = new ClipboardJS(`#${idPrefix}ReferralCopyButton`);
    clipboard.on('success', ()=> {
        $(`#${idPrefix}ReferralForm span.label-help`).removeClass('hide');
    });

    // modify urls and add them back to elements
    const mailtoUrl = $(`a#${idPrefix}ReferralEmailLink`).attr('href').replace(
        '{{link}}',
        encodeURIComponent(referralUrl)
    );

    $(`a#${idPrefix}ReferralEmailLink`).attr('href', mailtoUrl);

    // add sharing information
    const sharingEl = $(`#${idPrefix}ReferralSharing`);
    addSocialSharing(referralUrl, sharingEl);
}

function addMemberCodes(memberData) {
    addCodes(
        Framework.global.lt.globalPageDrivers.global.referralWelcome,
        memberData,
        'member',
        false
    );
    // display content
    LOADING_SPINNER_LG_ELEMENT.removeClass(constants.loadingSpinnerLgString);
    REFERRAL_MEMBER_CONTENT_ELEMENT.removeClass('hide').removeClass(constants.hiddenXsUpString);
}

function addTmCodes(teamMemberData) {
    addCodes(
        Framework.global.lt.globalPageDrivers.global.tmReferralWelcome,
        teamMemberData,
        'teammember',
        true
    );
}

function addDigitalMemberCodes(digitalMemberData) {
    addCodes(
        Framework.global.lt.globalPageDrivers.global.digitalReferralWelcome,
        digitalMemberData,
        'digital',
        false
    );
    LOADING_SPINNER_LG_ELEMENT.removeClass(constants.loadingSpinnerLgString);
}

function displayReferrerName(name) {
	REFERRER_NAME_ELEMENT.text(name);
	LOADING_SPINNER_LG_ELEMENT.removeClass(constants.loadingSpinnerLgString);
	REFERRER_TEXT_ELEMENT.removeClass(constants.hiddenXsUpString);
}

function storeReferralInfo(code, source) {
	Cookies.set(constants.memberReferralCookieName, code + '|' + source, {domain: '.lifetime.life', expires: 0});
}

function displayGenericFailureError(error) {
	LOADING_SPINNER_LG_ELEMENT.removeClass(constants.loadingSpinnerLgString);
	if(error.responseJSON && error.responseJSON.id) {
		REFERRAL_ERROR_SPAN_ELEMENT.text(error.responseJSON.id);
		REFERRAL_ERROR_ELEMENT.removeClass(constants.hiddenXsUpString);
	}
	$('#codeFailureText').removeClass(constants.hiddenXsUpString);
    REFERRAL_TM_ERROR_MSG.removeClass(constants.hiddenXsUpString);
}

function displayTmReferralError(error) {
    if(error.responseJSON && error.responseJSON.id) {
        REFERRAL_ERROR_SPAN_ELEMENT.text(error.responseJSON.id);
        REFERRAL_ERROR_ELEMENT.removeClass(constants.hiddenXsUpString);
    }

    if(error.message && error.message != "") {
        REFERRAL_ERROR_ELEMENT.removeClass(constants.hiddenXsUpString);
    }
    REFERRAL_TM_CONTENT_SHARE.addClass(constants.hiddenXsUpString);
    REFERRAL_TM_CONTENT_TEXT.addClass(constants.hiddenXsUpString);
    REFERRAL_TM_ERROR_MSG.removeClass(constants.hiddenXsUpString);
}

function displayTmReferralGenericError(error) {
    displayTmReferralError(error);
    $('#teammemberCodeFailureText').removeClass(constants.hiddenXsUpString);
}

function displayExceededLimitError(error) {
    displayTmReferralError(error)
    $('#teammemberValidationFailureText').removeClass(constants.hiddenXsUpString);
}

function displayDigitalReferralError() {
    REFERRAL_DIGITAL_CONTENT_SHARE.addClass(constants.hiddenXsUpString);
    REFERRAL_DIGITAL_CONTENT_TEXT.addClass(constants.hiddenXsUpString);
    REFERRAL_DIGITAL_ERROR_MSG.removeClass(constants.hiddenXsUpString);
    LOADING_SPINNER_LG_ELEMENT.removeClass(constants.loadingSpinnerLgString);
}

function displayGenericReferringText(error) {
	LOADING_SPINNER_LG_ELEMENT.removeClass(constants.loadingSpinnerLgString);
	if(error.responseJSON && error.responseJSON.id) {
		REFERRAL_ERROR_SPAN_ELEMENT.text(error.responseJSON.id);
		REFERRAL_ERROR_ELEMENT.removeClass(constants.hiddenXsUpString);
	}
	DEFAULT_TEXT_ELEMENT.removeClass(constants.hiddenXsUpString);
}

function addCampaignInfo(data, isTm) {
	$('.referral-bucks-count').text(data.rewardsBucks);
	var formattedDate = moment.utc(data.endDate).format('MMMM DD, YYYY');
	$('.referral-by-date').text(' by ' + formattedDate);
}

function getCodes(profile, isTm) {
	if(isTm) {
		// switch authored content
		REFERRAL_MEMBER_CONTENT_ELEMENT.remove();
        REFERRAL_TM_CONTENT_ELEMENT.removeClass('hide').removeClass(constants.hiddenXsUpString);
		// get code from service
		memberReferralService.api.getEmployeeReferralCode(profile.memberDetails.memberId, profile.partyId)
			.then(
				// success
				(tmData)=> {
                    addTmCodes(tmData);
                    getDigitalReferralCodes(profile);
				},
				// error
				(jqXHR)=> {
					if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.errorTypeIdentifier === 'EXCEEDED_LIMIT') {
						displayExceededLimitError(jqXHR);
					} else {
                        displayTmReferralGenericError(jqXHR);
					}
                    getDigitalReferralCodes(profile);
				}
			);
	} else{
		REFERRAL_TM_CONTENT_ELEMENT.remove();
		// get code from service
		memberReferralService.api.getReferralCode(profile.memberDetails.memberId)
			.then(
				// success
				(data)=> {
					addMemberCodes(data);
				},
				// error
				(jqXHR)=> {
					displayGenericFailureError(jqXHR);
				}
			);
	}
}

function getCouponCodes(isTm) {
	const cookieSsoId = Cookies.get(constants.cookieSsoId);
	if(isTm) {
		// switch authored content
		REFERRAL_MEMBER_CONTENT_ELEMENT.remove();
        REFERRAL_TM_CONTENT_ELEMENT.removeClass('hide').removeClass(constants.hiddenXsUpString);
		// get code from service
		memberReferralCouponService.api.getEmployeeReferralCoupon(cookieSsoId, "tmvip")
			.then(
				// success
				(tmData)=> {
					validateCodeResponse(tmData, isTm);
				},
				// error
				(jqXHR)=> {
                	displayTmReferralGenericError(jqXHR);
				}
			);
	} else {
		REFERRAL_TM_CONTENT_ELEMENT.remove();
		memberReferralCouponService.api.getEmployeeReferralCoupon(cookieSsoId, "referral")
			.then(
				// success
				(data)=> {
	 				validateCodeResponse(data, isTm);

				},
				// error
				(jqXHR)=> { //displayTmReferralGenericError
					displayGenericFailureError(jqXHR);
				}
			);
	}
}

function addDigitalReferralInfo(code, source) {
	_.forEach($('a.btn-primary.digital-referral'), (el)=> {
		let digitalLink = $(el).attr('href');
		digitalLink += '&referral=' + encodeURIComponent(code) + '&source=' + source;
		$(el).attr('href', digitalLink);
	});
}

function getReferrerInfo(code, source) {
	// if a source was passed in, we are not using the cookie and thus do not need to parse it
	if(source) {
		memberReferralService.api.getReferringMember(encodeURIComponent(code))
			.then(
				// success
				(data)=> {
					// replace span content with name of referrer
					displayReferrerName(data.firstName);
					// look for digital buttons and append url parameters
					addDigitalReferralInfo(code, source);
					// set cookie on user in case they return to page without referral code parameter
					storeReferralInfo(code, source);
				},
				// failure
				(jqXHR)=> {
					displayGenericReferringText(jqXHR);
				}
			);
	} else{
		// referral cookie has been passed in and we need to parse the code from the string to make api call
		const referralCode = code.split('|')[0];
		const referralSource = code.split('|')[1];
		memberReferralService.api.getReferringMember(encodeURIComponent(referralCode))
			.then(
				// success
				(data)=> {
					// replace span content with name of referrer
					displayReferrerName(data.firstName);
					// look for digital buttons and append url parameters
					addDigitalReferralInfo(referralCode, referralSource);
					// set cookie on user in case they return to page without referral code parameter
					storeReferralInfo(referralCode, referralSource);
				},
				// failure
				(jqXHR)=> {
					displayGenericReferringText(jqXHR);
				}
			);
	}
}

function getReferralCodeDetails(code, source)
{
	let referralCode;
	if(source) {
		// code is not coming from the cookie
		referralCode = encodeURIComponent(code);
	} else{
		// code is part of the cookie so we need to separate it from the source value
		referralCode = encodeURIComponent(code.split('|')[0]);
        source= code.split('|')[1];
	}

	memberReferralCouponService.api.validateReferralCode(referralCode)
		.then(
		// success
			(data)=> {
				if(data.isValid) {
					// replace span content with name of referrer
					displayReferrerName(data.referringMemberFirstName);
					// look for digital buttons and append url parameters
					addDigitalReferralInfo(code, source);
                   	// set cookie on user in case they return to page without referral code parameter

                   	storeReferralInfo(referralCode, source);
                   } else
                   	{
						window.location.href = Framework.global.lt.globalPageDrivers.global.referralError;
                 	}
			},
			// error
			(jqXHR, textStatus, errorThrown)=> {
				window.location.href = Framework.global.lt.globalPageDrivers.global.referralError;
			}
		);

}
function validateTeamMemberReferral(code, source) {
	let referralCode;
	if(source) {
		// code is not coming from the cookie
		referralCode = encodeURIComponent(code);
	} else{
		// code is part of the cookie so we need to separate it from the source value
		referralCode = encodeURIComponent(code.split('|')[0]);
	}

	// validate referral code
	memberReferralService.api.validateReferralCode(referralCode)
		.then(
			// success
			(validationData)=> {
				getReferrerInfo(code, source);
			},
			// error
			(jqXHR, textStatus, errorThrown)=> {
				window.location.href = Framework.global.lt.globalPageDrivers.global.referralError;
			}
	);
}

function getCampaignInfo(isTm) {
	return new Promise((resolve) => {
		if(isTm && isTm !== '') {
			memberReferralService.api.getEmployeeCampaignInfo()
				.then(
					(data)=> {
						addCampaignInfo(data, isTm);
						resolve();
					},
					(jqXHR)=> {
						resolve();
					}
				);
		} else{
			memberReferralService.api.getCampaignInfo()
				.then(
					(data)=> {
						addCampaignInfo(data);
						resolve();
					},
					(reason)=> {
						resolve();
					}
				);
		}
	});
}

function getDigitalReferralCodes(profile) {
    memberReferralService.api.getReferralCode(profile.memberDetails.memberId).then(
        (memberData) => {
            addDigitalMemberCodes(memberData);
        }, (jqXHR)=> {
            displayDigitalReferralError();
        });
}

$(document).on('ready', ()=> {
	// check if we are on the member referral page and not on author
	if(REFERRAL_ELEMENT.length > 0 && window.location.href.indexOf('author') <= 0) {
    	const employeeReferralsEnabled = authUtils.isFeatureFlagEnabled(constants.employeeReferralFeatureFlagId);
    	const newEmployeeReferralsAPIEnabled = authUtils.isFeatureFlagEnabled(constants.employeeReferralOmsMagentoApiFeatureFlagId);

		// grab profile info for member information
		const profileData = profileStore.getInitialData();
		let isTm = null;
		// check profile data status
		if(profileData.memberState !== constants.memberState.unknown) {
			if(profileData.memberState === constants.memberState.authenticated || profileData.memberState === constants.memberState.remembered) {
				// capture memberState
				if(profileData.memberDetails && profileData.memberDetails !== null) {
					isTm = profileData.memberDetails.isEmployee && employeeReferralsEnabled;

					if(newEmployeeReferralsAPIEnabled) {
						getCouponCodes(isTm);
					} else {
						getCampaignInfo(isTm).then(() => {
							getCodes(profileData, isTm);
						});
					}
				}
			} else{
				// redirect user
				window.location.href = Framework.global.lt.globalPageDrivers.global.loginResource;
			}
		} else{
			// listen for profileStore update
			var unsubToProfileStore = profileStore.listen((profile) => {
				if(profileData.memberState === constants.memberState.authenticated || profileData.memberState === constants.memberState.remembered) {
					if(profile.memberDetails && profile.memberDetails !== null) {
						isTm = profileData.memberDetails.isEmployee && employeeReferralsEnabled;
						if(newEmployeeReferralsAPIEnabled) {
								getCouponCodes(isTm);
                        } else {
							getCampaignInfo(isTm).then(() => {
								getCodes(profileData, isTm);
							});
						}
					}
				} else{
					// redirect user
					window.location.href = Framework.global.lt.globalPageDrivers.global.loginResource;
				}
				unsubToProfileStore();
			});
		}
	}

	// check if we are on the member referral landing page
	if(REFERRAL_LANDING_ELEMENT.length > 0 && Framework.global.lt.pageProperties.experienceType === constants.experienceTypeProspect) {
    	const employeeReferralsEnabled = authUtils.isFeatureFlagEnabled(constants.employeeReferralFeatureFlagId);
    	const newEmployeeReferralsAPIEnabled = authUtils.isFeatureFlagEnabled(constants.employeeReferralOmsMagentoApiFeatureFlagId);
		// identify if we need to do team member-specific logic
		const isTm = employeeReferralsEnabled ? urlUtils.queryStringParser('tm') : false;
		// grab url param and/or cookie
		const referralCodeParam = urlUtils.queryStringParser('referral');
		const referralSourceParam = urlUtils.queryStringParser('source');
		const storedReferralInfo = Cookies.get(constants.memberReferralCookieName);


		// if we receive referral information from the URL
		if((referralCodeParam && referralCodeParam.length > 0) && (referralSourceParam && referralSourceParam.length > 0)) {
			if(newEmployeeReferralsAPIEnabled) {
				getReferralCodeDetails(referralCodeParam, referralSourceParam);
			} else {
				if(isTm && isTm !== '') {
					validateTeamMemberReferral(referralCodeParam, referralSourceParam);
				} else{
					getReferrerInfo(referralCodeParam, referralSourceParam);
				}
			}
		// if there is no referral information in the URL, look for the cookie
		} else if(storedReferralInfo && storedReferralInfo.length > 0) {
			if(newEmployeeReferralsAPIEnabled) {
				getReferralCodeDetails(storedReferralInfo);
            } else {
				if(isTm && isTm !== '') {
					validateTeamMemberReferral(storedReferralInfo);
				} else{
					getReferrerInfo(storedReferralInfo);
				}
			}
		}
	}
});
